import { body2Styles } from "../../presets/typography";
import { colors } from "../../tokens/color";
import { breakpoints } from "../../tokens/size";
export const paginationStyles = {
    dots: (color) => (Object.assign(Object.assign({}, body2Styles), { color: color === 'blue' ? colors.text.activePrimary : colors.text.inverseActivePrimary })),
    pagination: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
    },
    desktopPagination: {
        [`@media (max-width: ${breakpoints.sm})`]: {
            display: 'none',
        },
    },
    mobilePagination: {
        [`@media (min-width: ${breakpoints.sm})`]: {
            display: 'none',
        },
    },
};
